import React, { FunctionComponent, useEffect, useState } from 'react';
import { Table, Spin, Empty } from 'antd';
import { useStore } from 'effector-react';
import { useParams } from 'react-router';
import css from './UserChatClaims.module.less';
import IUser from '@interfaces/IUser';
import componentContent from './UserChatClaims.content.json';
import useTranslate from '@hooks/useTranslate';
import chatClaims, { getList } from '@stores/chat-claims';

interface UserChatClaimsProps {}

const UserChatClaims: FunctionComponent<UserChatClaimsProps> = () => {
  const { preloaders } = useStore(chatClaims);
  const { userId } = useParams<{ userId: IUser['id'] }>();
  const [chatClaimsTable, setChatClaimsTable] = useState<any[]>([]);

  const content = useTranslate(componentContent);

  useEffect(() => {
    if (userId) {
      getList(userId).then(({ data }) => {
        const result = data?.body?.result?.page || [];
        setChatClaimsTable(result);
      });
    }
  }, [userId]);

  const columns = [
    {
      title: content.text,
      dataIndex: 'text',
      key: 'text',
    },
    {
      title: content.created,
      dataIndex: 'created',
      key: 'created',
    },
    {
      title: content.nickname,
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: content.chatOrTribe,
      dataIndex: 'chatOrTribe',
      key: 'chatOrTribe',
    },
    {
      title: content.reason,
      dataIndex: 'type',
      key: 'type',
    },
  ];

  const dataSource = chatClaimsTable.map((claim: any) => ({
    id: claim.id,
    text: claim.text,
    created: new Date(claim.created).toLocaleString(),
    nickname: claim.chattedWith?.nickname || '-',
    chatOrTribe: claim.chatId || claim.tribe?.chatId || '-',
    type: claim.type,
  }));

  const isListLoading = !!preloaders.getList;

  if (!dataSource.length && !isListLoading) {
    return <Empty />;
  }

  return (
    <div className={css.tableContainer}>
      <Spin spinning={isListLoading}>
        <Table
          dataSource={dataSource}
          columns={columns}
          rowKey={(record) => record.id}
        />
      </Spin>
    </div>
  );
};

export default UserChatClaims;
